var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.9987 1.33301L10.0587 5.50634L14.6654 6.17968L11.332 9.42634L12.1187 14.013L7.9987 11.8463L3.8787 14.013L4.66536 9.42634L1.33203 6.17968L5.9387 5.50634L7.9987 1.33301Z","fill":"#EEC200","stroke":"#EEC200","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Star.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Star;

Star.default = Star;
